import { AppstoreAddOutlined } from '@ant-design/icons';
import { getActivityNameAndId, type GetActivityNameAndIdType } from '@repo/crm-atoms';
import { useGetGraphqlDataQuery, type UseQueryResult } from '@repo/services';
import { type NodeProps } from '@xyflow/react';
import AddLeadActivityMenu from 'automations/components/Nodes/AddLeadActivityMenu';
import { type AddLeadActivityNodeType } from 'automations/types/nodeSchemas/actionNodes';
import { nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type ActionNodeReturnProps } from './useActionNodeConfig';

export default function useAddLeadActivity(node: NodeProps<AddLeadActivityNodeType>): ActionNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.AddLeadActivityActionNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <AddLeadActivityMenu node={node} />, [node]);

  const selectedActivityId = node.data?.additionalOptions?.addLeadActivity?.activityId;

  const {
    data,
  } = useGetGraphqlDataQuery<UseQueryResult<GetActivityNameAndIdType>>({
    document: getActivityNameAndId,
    variables: {
      activityIds: [selectedActivityId],
    },
  }, {
    skip: !selectedActivityId,
  });

  const subTitle = useMemo(() => {
    if (!data?.activities?.[0]?.displayName) return null;

    return `Add Activity: ${data?.activities?.[0]?.displayName}`;
  }, [data]);

  return {
    subTitle,
    icon: AppstoreAddOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
